import {css} from '@yandex-delivery/blocks/theme/css'

const ICON_BOX_HEIGHT = 56
const ICON_WIDTH = 40
const NO_ICON_WIDTH = 14
const CONNECTOR_WIDTH = 6
const ICON_PADDING = 4
const SPOTLIGHT_SIZE = 48

export const classes = {
  row: css`
    display: flex;
    inline-size: 100%;
    align-items: center;
    justify-content: flex-start;
  `,

  // Левая колонка с датой и временем
  leadColumn: css`
    inline-size: 56px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  `,

  leadTitle: css`
    text-align: end;
    font-weight: 500;
  `,

  leadSubtitle: css`
    text-align: end;
  `,

  // Центральная колонка с иконкой и линиями
  iconColumn: css`
    position: relative;
    padding-inline: ${ICON_PADDING}px;
    inline-size: ${ICON_BOX_HEIGHT}px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  // Верхний коннектор: от центра к верху (Alignment.TopCenter в Android)
  connectorTop: css`
    position: absolute;
    inset-block-end: 50%;
    inset-inline-start: 50%;
    transform: translateX(-50%);
    inline-size: ${CONNECTOR_WIDTH}px;
    z-index: 0;
  `,

  // Нижний коннектор: от центра к низу (Alignment.BottomCenter в Android)
  connectorBottom: css`
    position: absolute;
    inset-block-start: 50%;
    inset-inline-start: 50%;
    transform: translateX(-50%);
    inline-size: ${CONNECTOR_WIDTH}px;
    z-index: 0;
  `,

  iconWrapper: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  `,

  iconSpot: css`
    inline-size: ${ICON_WIDTH}px;
    block-size: ${ICON_WIDTH}px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  `,

  iconSpotSmall: css`
    inline-size: ${NO_ICON_WIDTH}px;
    block-size: ${NO_ICON_WIDTH}px;
  `,

  iconSpotlight: css`
    position: absolute;
    inline-size: ${SPOTLIGHT_SIZE}px;
    block-size: ${SPOTLIGHT_SIZE}px;
    border-radius: 50%;
    z-index: 0;
  `,

  icon: css`
    inline-size: 24px;
    block-size: 24px;
  `,

  // Правая колонка с текстом
  trailColumn: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
  `,

  title: css`
    padding-block-start: 12px;
    max-inline-size: 100%;
  `,

  titleWithSubtitle: css`
    padding-block-end: 0;
  `,

  subtitle: css`
    padding-block-end: 12px;
    max-inline-size: 100%;
  `,
}
